export const handleAction = (state = [], { type, context }) => {
  switch (type) {
    case 'WishlistApi.Wishlist.add.loading':
    case 'WishlistApi.Wishlist.update.loading':
      return [...state, context?.sku];
    case 'WishlistApi.Wishlist.add.success':
    case 'WishlistApi.Wishlist.update.success':
    case 'WishlistApi.Wishlist.update.error':
    case 'WishlistApi.Wishlist.add.error':
      return state.filter(sku => sku !== context?.sku);
  }

  return state;
};
